import { StringUtils } from "../../../../utils/stringUtils";
import { ReportProps, ValidationError, Validator } from "../../../../types/types";

export class QueryEditorValidator implements Validator<ReportProps> {

    validate(props: ReportProps): ValidationError[] {
        const info=props.queryInfo;
        const errors: ValidationError[] = [];
        if (StringUtils.isEmpty(info.query))
            errors.push(new ValidationError("queryValueError", "Please provide Query !"))
     
        if (StringUtils.isEmpty(info.name))
            errors.push(new ValidationError("queryNameError", "Please give meaningful query name !"))
            if (props.queryFlag["Not Allowed"]?.length === 0 && props.queryFlag.Warning?.length === 0) {
                errors.push(new ValidationError("noApiResponse", "Please analyse and optimise the query !"))
            }
         if(props.queryFlag["Not Allowed"]?.length > 0){
            errors.push(new ValidationError("notAllowedAnalyseError", "Please analyse the query !"))
         }

       return errors;
    }
}